import { render, staticRenderFns } from "./ReportPDPA.vue?vue&type=template&id=913ccdd0&"
import script from "./ReportPDPA.vue?vue&type=script&lang=js&"
export * from "./ReportPDPA.vue?vue&type=script&lang=js&"
import style0 from "./ReportPDPA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports